import { takeLatest, put, call } from "redux-saga/effects";
import {
  SEARCH_SAP_GET_DATA,
  SEARCH_SAP_GET_DETAIL_API,
  STORE_CALL_VISIT_POST,
  STORE_CALL_VISIT_GET,
  STORE_CALL_VISIT_API,
  STORE_CALL_VISIT_SEND_MAIL_POST,
  STORE_CALL_VISIT_SEND_MAIL_POST_API,
  STORE_CALL_VISIT_GET_VENDOR_DATA,
  STORE_CALL_VISIT_VENDOR_API,

} from "./Constants";
import {
  setSearchSAPGetDataSuccess,
  setSearchSAPGetDataFail,
  setStoreCallVisitPostSuccess,
  setStoreCallVisitPostFail,
  setStoreCallVisitGetSuccess,
  setStoreCallVisitGetFail,
  setStoreCallVisitSendMailPostSuccess,
  setStoreCallVisitSendMailPostFail,
  setStoreCallVisitGetVendorDataSuccess,
  setStoreCallVisitGetVendorDataFail,
} from "./Actions";
import {
  getDetailRequest,
  getRequest,
  postRequest,
} from "../../../shared/components/Service";
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";

/* ================= GET SEARCH SAP ================= */

function* getSearchSAPDataService({ id }) {
  try {
    const response = yield call(getDetailRequest, SEARCH_SAP_GET_DETAIL_API + id);
    if (response.status === 200) {
      yield put(setSearchSAPGetDataSuccess(response.data));
    } else {
      yield put(setSearchSAPGetDataFail(response.response.data));
    }
  } catch (error) {
    yield put(setSearchSAPGetDataFail(error));
  }
}

/* ================= POST STORE CALL/VISIT ================= */

function* postStoreCallVisitService({ payload }) {
  try {
    const response = yield call(postRequest, STORE_CALL_VISIT_API, payload);
    if (response.status === 200 || response.status === 201) {
      yield put(setStoreCallVisitPostSuccess(response.data));
      yield put(addSuccessAlert(response.data?.msg || "Store visit created successfully"));
    } else {
      yield put(setStoreCallVisitPostFail(response.response?.data));
      yield put(addErrorAlert(response.response?.data?.msg || "Failed to create store visit"));
    }
  } catch (error) {
    yield put(setStoreCallVisitPostFail(error));
    yield put(addErrorAlert("Failed to create store visit"));
  }
}

/* ================= GET STORE VISIT LIST ================= */
// params: { status, event_date, store_location_id }

function* getStoreCallVisitService({ params }) {
  try {
    const queryParams = new URLSearchParams();
    if (params?.store_location_id) queryParams.append("store_location_id", params.store_location_id);

    const url = queryParams.toString()
      ? `${STORE_CALL_VISIT_API}?${queryParams.toString()}`
      : STORE_CALL_VISIT_API;

    const response = yield call(getRequest, url);
    if (response.status === 200) {
      yield put(setStoreCallVisitGetSuccess(response.data));
    } else {
      yield put(setStoreCallVisitGetFail(response.response?.data));
    }
  } catch (error) {
    yield put(setStoreCallVisitGetFail(error));
  }
}

function* postStoreCallVisitSendMailService({ payload }) {
  try {
    const response = yield call(postRequest, STORE_CALL_VISIT_SEND_MAIL_POST_API, payload);
    if (response.status === 200 || response.status === 201) {
      yield put(setStoreCallVisitSendMailPostSuccess(response.data));
      yield put(addSuccessAlert(response.data?.msg || "Mail sent"));
    } else {
      yield put(setStoreCallVisitSendMailPostFail(response.response?.data));
      yield put(addErrorAlert(response.response?.data?.msg || "Failed to send mail"));
    }
  } catch (error) {
    yield put(setStoreCallVisitSendMailPostFail(error));
    yield put(addErrorAlert("Failed to send mail"));
  }
}

// Get vendor
function* getStoreCallVisitVendorDataService({ params }) {
  try {
    const queryParams = new URLSearchParams();
    if (params?.store_location_id)
      queryParams.append("store_location_id", params.store_location_id);

    const url = queryParams.toString()
      ? `${STORE_CALL_VISIT_VENDOR_API}?${queryParams.toString()}`
      : STORE_CALL_VISIT_VENDOR_API;

    const response = yield call(getRequest, url);
    if (response.status === 200) {
      yield put(setStoreCallVisitGetVendorDataSuccess(response.data));
    } else {
      yield put(setStoreCallVisitGetVendorDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(setStoreCallVisitGetVendorDataFail(error));
  }
}


/* ================= WATCHERS ================= */

export function* watchSearchSAP() {
  yield takeLatest(
    SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_LOAD,
    getSearchSAPDataService
  );
  yield takeLatest(
    STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_LOAD,
    postStoreCallVisitService
  );
  yield takeLatest(
    STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_LOAD,
    getStoreCallVisitService
  );
  yield takeLatest(
    STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_LOAD,
    postStoreCallVisitSendMailService
  );
  yield takeLatest(
    STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_LOAD,
    getStoreCallVisitVendorDataService
  );
}